import { useEffect, useState } from "react";
import { Grid, Box } from "@mui/material";
import { api } from "../api";
import CategoryCard from "../components/CategoryCard";
import PageTitle from "../components/Title";

export default function Categories({ onSelectCategory }) {
  const [categories, setCategories] = useState([]);
  

  useEffect(() => {
    api.getCategories().then(setCategories);
  }, []);

  return (
    <Box sx={{ mt: { xs: 4, md: 8 } }}>
      <PageTitle
        title="Academia"
        subtitle="Selectionne une catégorie pour t'entraîner"
      />

      <Grid container spacing={4} justifyContent="center">
        {categories.map((category) => (
          <Grid
            item
            key={category.id}
            xs={12}
            sm={6}
            md="auto"
            display="flex"
            justifyContent="center"
          >
            <CategoryCard
              category={category}
              onClick={() => onSelectCategory(category.id)}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
